"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _clientMutation = require("@/apollo/mutations/client-mutation");
var _auth = require("@/utils/auth");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var _timeUtil = require("@/utils/time-util");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      form: [{
        id: null,
        file_type: 0,
        file_url: '',
        client_id: '',
        is_acceptance: false,
        title: '',
        create_date: '',
        date_of_acceptance: '',
        attach_file_type: 1,
        file_name: ''
      }],
      expiration_date: '',
      expiration_flag: false,
      submitBtnName: '追加',
      loading: false,
      centerDialogVisible: false,
      centerDialogVisibleCancel: false,
      waitDialogVisible: false
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this = this;
      var res, expiration_date, now_date, _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setClientDocumentID)(this.$route.params.id);
            }
            _context2.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_CONTRACT,
              variables: {
                id: (0, _auth.getClientDocumentID)()
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 1:
            res = _context2.sent;
            this.$data.form = res.data.client_file_link;
            if (res.data.client_file_link[0].date_of_acceptance !== null) {
              expiration_date = new Date(res.data.client_file_link[0].date_of_acceptance);
              expiration_date.setDate(expiration_date.getDate() + 5);
              this.expiration_date = expiration_date;
            }
            _context2.next = 2;
            return _axios.default.head(window.location.href).then(/*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                var _t;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      now_date = new Date(res.headers.date); // サーバー時刻
                      if (!(_this.$data.form[0].date_of_acceptance !== null)) {
                        _context.next = 3;
                        break;
                      }
                      _context.next = 1;
                      return _this.lowerThanDateOnly(now_date, _this.expiration_date);
                    case 1:
                      _t = _context.sent;
                      if (!(_t === false)) {
                        _context.next = 2;
                        break;
                      }
                      _this.expiration_flag = true;
                    case 2:
                      _context.next = 4;
                      break;
                    case 3:
                      _this.expiration_flag = false;
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          case 2:
            _context2.next = 3;
            return _apolloClient.apolloClient.mutate({
              mutation: _clientMutation.UPDATE_CLIENT_READING_FLAG,
              variables: {
                id: (0, _auth.getClientDocumentID)(),
                client_reading_flag: false
              }
            }).then(function (result) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
              console.log('updateClientReadingFlagError');
            });
          case 3:
            _context2.next = 4;
            return (0, _appUtil.checkReadingFlag)(true);
          case 4:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 5;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _t3;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return _apolloClient.apolloClient.mutate({
              mutation: _clientMutation.UPDATE_CLIENT_READING_FLAG,
              variables: {
                id: (0, _auth.getClientDocumentID)(),
                client_reading_flag: false
              }
            }).then(function (result) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
              console.log('updateClientReadingFlagError');
            });
          case 1:
            _context3.next = 2;
            return (0, _appUtil.checkReadingFlag)(false);
          case 2:
            _t3 = _context3.sent;
            if (!(_t3 === true)) {
              _context3.next = 3;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    backToContractIndex: function backToContractIndex() {
      return this.$router.push({
        name: 'ContractIndex'
      });
    },
    updateApproval: function () {
      var _updateApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(id, acceptance) {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log('updateApproval');
              _context4.next = 1;
              return _apolloClient.apolloClient.mutate({
                mutation: _clientMutation.UPDATE_CONTRACT_APPROVAL,
                variables: {
                  id: id,
                  is_acceptance: acceptance
                }
              }).then(function (result) {
                _apolloClient.apolloClient.resetStore();
                console.log('updateApprovalResolve');
                var resultUpdateApproval = result.data.update_client_file_link.returning[0];
                return Promise.resolve(resultUpdateApproval);
              }).catch(function (error) {
                console.log('updateApprovalError');
                return Promise.reject(error);
              });
            case 1:
              return _context4.abrupt("return", _context4.sent);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function updateApproval(_x2, _x3) {
        return _updateApproval.apply(this, arguments);
      }
      return updateApproval;
    }(),
    approvalProcess: function () {
      var _approvalProcess = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.centerDialogVisible = false;
              this.waitDialogVisible = true;
              _context5.next = 1;
              return this.updateApproval((0, _auth.getClientDocumentID)(), true).then(function (resultClient) {
                return Promise.resolve(resultClient);
              }).then(function (result) {
                _this2.loading = false;
                _this2.waitDialogVisible = false;
                _this2.$notify({
                  title: '成功',
                  message: '承認処理が完了しました。',
                  type: 'success',
                  duration: 5000
                });
                return _this2.$router.push({
                  name: 'ContractIndex'
                });
              }).catch(function (error) {
                console.log(error);
                _this2.loading = false;
                _this2.waitDialogVisible = false;
                _this2.$notify({
                  title: '失敗',
                  message: '承認処理に失敗しました。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 1:
              return _context5.abrupt("return", _context5.sent);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function approvalProcess() {
        return _approvalProcess.apply(this, arguments);
      }
      return approvalProcess;
    }(),
    cancelProcess: function () {
      var _cancelProcess = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.centerDialogVisibleCancel = false;
              this.waitDialogVisible = true;
              _context6.next = 1;
              return this.updateApproval((0, _auth.getClientDocumentID)(), false).then(function (resultClient) {
                return Promise.resolve(resultClient);
              }).then(function (result) {
                _this3.loading = false;
                _this3.waitDialogVisible = false;
                _this3.$notify({
                  title: '成功',
                  message: '承認取り消し処理が完了しました。',
                  type: 'success',
                  duration: 5000
                });
                return _this3.$router.push({
                  name: 'ContractIndex'
                });
              }).catch(function (error) {
                console.log(error);
                _this3.loading = false;
                _this3.waitDialogVisible = false;
                _this3.$notify({
                  title: '失敗',
                  message: '承認取り消し処理に失敗しました。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 1:
              return _context6.abrupt("return", _context6.sent);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function cancelProcess() {
        return _cancelProcess.apply(this, arguments);
      }
      return cancelProcess;
    }(),
    approval: function approval() {
      this.centerDialogVisible = true;
    },
    cancel: function cancel() {
      this.centerDialogVisibleCancel = true;
    },
    displayAcceptanceType: function displayAcceptanceType(val, date_of_acceptance) {
      if (val === _DocumentCategory.DocumentCategory.Acceptance.TRUE.val) {
        return _DocumentCategory.DocumentCategory.Acceptance.TRUE.label;
      }
      if (date_of_acceptance !== null) {
        return _DocumentCategory.DocumentCategory.Acceptance.CANCEL.label;
      }
      return _DocumentCategory.DocumentCategory.Acceptance.FALSE.label;
    },
    displayDocumentType: function displayDocumentType(val) {
      if (val === _DocumentCategory.DocumentCategory.UserDocumentType.Contract.val) {
        return _DocumentCategory.DocumentCategory.UserDocumentType.Contract.label;
      } else if (val === _DocumentCategory.DocumentCategory.UserDocumentType.EmploymentStatement.val) {
        return _DocumentCategory.DocumentCategory.UserDocumentType.EmploymentStatement.label;
      }
      return '未設定';
    },
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    },
    lowerThanDateOnly: function () {
      var _lowerThanDateOnly = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(date1, date2) {
        var year1, month1, day1, year2, month2, day2;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              year1 = date1.getFullYear();
              month1 = date1.getMonth() + 1;
              day1 = date1.getDate();
              year2 = date2.getFullYear();
              month2 = date2.getMonth() + 1;
              day2 = date2.getDate();
              if (!(year1 === year2)) {
                _context7.next = 3;
                break;
              }
              if (!(month1 === month2)) {
                _context7.next = 1;
                break;
              }
              return _context7.abrupt("return", day1 <= day2);
            case 1:
              return _context7.abrupt("return", month1 < month2);
            case 2:
              _context7.next = 4;
              break;
            case 3:
              return _context7.abrupt("return", year1 < year2);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function lowerThanDateOnly(_x4, _x5) {
        return _lowerThanDateOnly.apply(this, arguments);
      }
      return lowerThanDateOnly;
    }()
  }
};